var map = {
	"./Next.png": "b3e7",
	"./Pause.png": "d390",
	"./Play.png": "6d73",
	"./Previous.png": "a13a",
	"./Settings.png": "e9e8",
	"./logo.png": "cf05",
	"./photos/close.png": "ea1a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";